import { useMutation } from '@tanstack/react-query';

import type { OpportunityList } from '../../../domain/list';
import { useUseCases } from '../../../UseCaseProvider';

export const useSaveDomainToListMutation = () => {
  const { saveDomainToList } = useUseCases();
  return useMutation({
    mutationKey: ['save-domain-to-list'],
    mutationFn: ({ domain, list }: { domain: string; list: OpportunityList }) => saveDomainToList({ domain, list }),
  });
};
